module.exports = __webpack_public_path__ + "static/media/undraw_My_location_re_r52x 1.e2cd0160.svg";